export const CATEGORY_MAP = {
  infaq_ranting: { label: "Infaq Ranting", fund: "infaq", direction: "in" },
  infaq_madrasah: { label: "Infaq Madrasah", fund: "infaq", direction: "in" },
  infaq_dopbox: { label: "Infaq Dopbox", fund: "infaq", direction: "in" },
  infaq_individu: { label: "Infaq Individu", fund: "infaq", direction: "in" },
  infaq_layanan: { label: "Infaq Layanan", fund: "infaq", direction: "in" },
  zakat_profesi: { label: "Zakat Profesi", fund: "zakat", direction: "in" },
  zakat_mal: { label: "Zakat Mal", fund: "zakat", direction: "in" },
  zakat_fitrah: { label: "Zakat Fitrah", fund: "zakat", direction: "in" },
  zakat_pertanian: { label: "Zakat Pertanian", fund: "zakat", direction: "in" },
  csr_perusahaan: { label: "CSR Perusahaan", fund: "infaq", direction: "in" },
  qurban: { label: "Qurban", fund: "infaq", direction: "in" },
  program_khusus: { label: "Program Khusus", fund: "infaq", direction: "in" },
  pentasyarufan_program: { label: "Pentasyarufan Program", fund: "infaq", direction: "out" },
  pentasyarufan_organisasi: { label: "Pentasyarufan Organisasi", fund: "infaq", direction: "out" },
  pentasyarufan_ranting: { label: "Pentasyarufan Ranting", fund: "infaq", direction: "out" },
  pentasyarufan_layanan: { label: "Pentasyarufan Layanan", fund: "infaq", direction: "out" },
  fundraising: { label: "Fundraising", fund: "infaq", direction: "out" },
  biaya_infaq: { label: "Biaya Infaq", fund: "infaq", direction: "out" },
  daging_qurban: { label: "Daging Qurban", fund: "infaq", direction: "out" },
  bedah_rumah: { label: "Bedah Rumah", fund: "infaq", direction: "out" },
  lainnya: { label: "Lainnya", fund: "infaq", direction: "out" },
  zakat_produktif: { label: "Zakat Produktif", fund: "zakat", direction: "out" },
  pentasyarufan_zakat: { label: "Pentasyarufan Zakat", fund: "zakat", direction: "out" },
};

export const PENERIMAAN_TABS = [
  {
    key: "infaq",
    label: "Infaq",
    categories: [
      { key: "infaq_ranting", label: "Infaq Ranting" },
      { key: "infaq_madrasah", label: "Infaq Madrasah" },
      { key: "infaq_dopbox", label: "Infaq Dopbox" },
      { key: "infaq_individu", label: "Infaq Individu" },
      { key: "infaq_layanan", label: "Infaq Layanan" },
    ],
  },
  {
    key: "zakat",
    label: "Zakat",
    categories: [
      { key: "zakat_profesi", label: "Zakat Profesi" },
      { key: "zakat_mal", label: "Zakat Mal" },
      { key: "zakat_fitrah", label: "Zakat Fitrah" },
      { key: "zakat_pertanian", label: "Zakat Pertanian" },
    ],
  },
  {
    key: "sedekah",
    label: "Sedekah / DSKL",
    categories: [
      { key: "csr_perusahaan", label: "CSR Perusahaan" },
      { key: "qurban", label: "Qurban" },
      { key: "program_khusus", label: "Program Khusus" },
    ],
  },
];

export const PENTASYARUFAN_TABS = [
  {
    key: "infaq",
    label: "Infaq / Sedekah / DSKL",
    categories: [
      { key: "pentasyarufan_program", label: "Pentasyarufan Program" },
      { key: "pentasyarufan_organisasi", label: "Pentasyarufan Organisasi" },
      { key: "pentasyarufan_ranting", label: "Pentasyarufan Ranting" },
      { key: "pentasyarufan_layanan", label: "Pentasyarufan Layanan" },
      { key: "fundraising", label: "Fundraising" },
      { key: "biaya_infaq", label: "Biaya Infaq" },
      { key: "daging_qurban", label: "Daging Qurban" },
      { key: "bedah_rumah", label: "Bedah Rumah" },
      { key: "lainnya", label: "Lainnya" },
    ],
  },
  {
    key: "zakat",
    label: "Zakat",
    categories: [
      { key: "zakat_produktif", label: "Zakat Produktif" },
      { key: "pentasyarufan_zakat", label: "Pentasyarufan Zakat" },
    ],
  },
];

export const ASSET_CATEGORIES = [
  { key: "armada_layanan", label: "Armada Layanan" },
  { key: "perabot_kantor", label: "Perabot Kantor" },
  { key: "sekretariat", label: "Sekretariat" },
];

export const ASSET_CONDITIONS = [
  { key: "baik", label: "Baik" },
  { key: "rusak_ringan", label: "Rusak Ringan" },
  { key: "rusak_berat", label: "Rusak Berat" },
];

export const CONDITION_LABELS = {
  baik: "Baik",
  rusak_ringan: "Rusak Ringan",
  rusak_berat: "Rusak Berat",
};

export const categoryLabel = (key) => CATEGORY_MAP[key]?.label || key;

export const formatIDR = (n) =>
  "Rp " + new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(Math.round(Number(n) || 0));

export const formatDate = (s) => {
  if (!s) return "-";
  const d = new Date(`${s}T00:00:00`);
  if (isNaN(d.getTime())) return s;
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
};

export const today = () => new Date().toISOString().slice(0, 10);

export const CONTACT_GROUPS = [
  {
    key: "donatur",
    label: "Donatur",
    types: [
      { key: "munfiq", label: "Munfiq", person: true },
      { key: "koin_nu", label: "KOIN NU", person: true },
      { key: "muzaki", label: "Muzaki", person: true },
      { key: "mudhokhi", label: "Mudhokhi", person: true },
      { key: "ranting", label: "Ranting", person: false },
      { key: "instansi", label: "Instansi", person: false },
    ],
  },
  {
    key: "penerima_manfaat",
    label: "Penerima Manfaat",
    types: [
      { key: "yatama", label: "Yatama", person: true },
      { key: "santunan_pendidikan", label: "Santunan Pendidikan", person: true },
      { key: "santunan_dhuafa", label: "Santunan Dhuafa", person: true },
      { key: "santunan_guru_ngaji", label: "Santunan Guru Ngaji", person: true },
      { key: "pemberdayaan_ppi", label: "Pemberdayaan PPI", person: true },
      { key: "peduli_marbot", label: "Peduli Marbot", person: true },
      { key: "layanan_mlu", label: "Layanan MLU", person: true },
      { key: "khitan", label: "Khitan Sehat Gratis", person: false },
      { key: "pinjam_alat", label: "Pinjam Alat Kesehatan", person: false },
      { key: "kartu_sehat", label: "Kartu Sehat Gratis", person: true },
      { key: "bedah_rumah", label: "Bedah Rumah", person: true },
      { key: "nusantara_berqurban", label: "Nusantara Berqurban", person: true },
      { key: "kebencanaan", label: "Kebencanaan", person: true },
    ],
  },
];

export const CONTACT_TYPES = CONTACT_GROUPS.flatMap((g) => g.types);

export const GENDERS = [
  { key: "L", label: "Laki-laki" },
  { key: "P", label: "Perempuan" },
];

export const LAYANAN_DESTINATIONS = [
  { key: "rs", label: "RS (Rumah Sakit)" },
  { key: "klinik", label: "Klinik" },
  { key: "lainnya", label: "Lainnya" },
];

export const LAYANAN_CARE_TYPES = [
  { key: "rawat_jalan", label: "Rawat Jalan" },
  { key: "rawat_inap", label: "Rawat Inap" },
  { key: "igd", label: "IGD" },
];

export const LAYANAN_CONDITIONS = [
  { key: "berbaring", label: "Berbaring" },
  { key: "duduk", label: "Duduk" },
];

export const LAYANAN_STATUSES = [
  { key: "baru", label: "Baru" },
  { key: "diproses", label: "Diproses" },
  { key: "selesai", label: "Selesai" },
  { key: "batal", label: "Batal" },
];

export const EQUIPMENT_OPTIONS = [
  { key: "kursi_roda", label: "Kursi Roda" },
  { key: "kruk", label: "Kruk" },
  { key: "tabung_oksigen_kecil", label: "Tabung Oksigen Kecil" },
];

export const EQUIPMENT_CONDITIONS = [
  { key: "sakit", label: "Sakit" },
  { key: "kesulitan_berjalan", label: "Kesulitan Berjalan" },
  { key: "kesulitan_bernafas", label: "Kesulitan Bernafas" },
  { key: "faktor_usia", label: "Faktor Usia" },
];

export const EQUIPMENT_DURATIONS = [
  { key: "1_bulan", label: "1 Bulan" },
  { key: "3_bulan", label: "3 Bulan" },
  { key: "6_bulan", label: "6 Bulan" },
  { key: "12_bulan", label: "12 Bulan" },
];

export const optionLabel = (list, key) => list.find((x) => x.key === key)?.label || key || "-";

export const ROLE_LABELS = {
  admin: "Admin",
  pengurus: "Pengurus",
  operator: "Operator",
  koordinator_layanan: "Koordinator Layanan",
  driver: "Driver",
};

export const REGISTER_ROLES = [
  { key: "pengurus", label: "Pengurus — input & edit data" },
  { key: "operator", label: "Operator — input data" },
  { key: "koordinator_layanan", label: "Koordinator Layanan — input & edit data layanan" },
  { key: "driver", label: "Driver — lihat & ubah status layanan" },
];

export const canEditData = (role) => ["admin", "pengurus"].includes(role);
export const canEditLayanan = (role) => ["admin", "pengurus", "koordinator_layanan"].includes(role);
export const canChangeLayananStatus = (role) => ["admin", "pengurus", "koordinator_layanan", "driver"].includes(role);
export const canCreateLayanan = (role) => ["admin", "pengurus", "operator", "koordinator_layanan"].includes(role);

export const KHITAN_CHILD_STATUSES = [
  { key: "yatim", label: "Yatim" },
  { key: "piatu", label: "Piatu" },
  { key: "yatim_piatu", label: "Yatim-Piatu" },
  { key: "dhuafa", label: "Dhuafa" },
];

export const BANK_ACCOUNTS = [
  { label: "Donasi, Infaq & Sedekah", bank: "BRI", number: "5922 01 026778 53 1" },
  { label: "Santunan YATAMA", bank: "BRI", number: "5922 01 044183 53 2" },
];

export const GOZIS_WA_URL = `https://wa.me/628112999157?text=${encodeURIComponent("Assalamu'alaikum, saya ingin menggunakan layanan Go-ZIS")}`;
